"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _configuration = require("../../configuration");

var _default = (0, _configuration.ConfigurationSchema)('BaseConnection', {
  name: {
    type: 'string',
    defaultValue: 'nameOfConnection',
    description: 'a unique name for this connection'
  },
  assemblyNames: {
    type: 'stringArray',
    defaultValue: [],
    description: 'optional list of names of assemblies in this connection'
  }
}, {
  explicitlyTyped: true,
  explicitIdentifier: 'connectionId'
});

exports.default = _default;